import React from "react";
import Home from "./components/Home";
import "./App.css";
import CacheBuster from "react-cache-buster";
import appversion from "../package.json";
import { CookieSetting } from "cookiesetting-component";

const appVersion = appversion.version;

export default function App() {
  return (
    <CacheBuster
    currentVersion={appVersion}
    isEnabled={true}
    isVerboseMode={false}
    metaFileDirectory={"."}
  >
    <Home />
    <CookieSetting 
        privacyPolicyLink={process.env.REACT_APP_PRIVACY_POLICY_LINK} 
        configUrl={process.env.REACT_APP_COOKIE_SETTING_JSON}
        analytics={process.env.REACT_APP_ANALYTICS_PATH}
      />
    </CacheBuster>
  );
}
